import API from '../../../classes/API/API';
import URL from '../../../classes/URL/URL';

export async function auth() {
  return await new API(`${URL.URL_SERVER}/auth`).post({});
}
